// import {
//   getBaseUrl,
//   getDeviceId,
//   getRefreshToken,
//   getUserToken
// } from '@/lib/GetBaseUrl'
// import { Logout } from '@/lib/handleLogout'
// import { nookieProvider } from '@/lib/nookieProvider'
// import { clearAddress } from '@/redux/features/addressSlice'
// import { clearCart } from '@/redux/features/cartSlice'
// import { logout } from '@/redux/features/userSlice'
// import axios from 'axios'
// import { setCookie } from 'nookies'

// // Function to validate token
// export const getValidatedToken = async ({
//   accessToken = null,
//   deviceId = null,
//   refreshToken = null,
//   userId = null
// }) => {
//   let queryParams = ''
//   if (refreshToken || userId) {
//     queryParams = `?AccessToken=${encodeURIComponent(
//       accessToken
//     )}&RefreshToken=${encodeURIComponent(
//       refreshToken
//     )}&DeviceId=${deviceId}&UserId=${userId}`
//   } else {
//     queryParams = `?AccessToken=${encodeURIComponent(
//       accessToken
//     )}&DeviceId=${encodeURIComponent(deviceId)}`
//   }

//   try {
//     const response = await axios.get(
//       `${getBaseUrl()}Account/Customer/ValidateToken${queryParams}`
//     )

//     if (response?.data?.code === 200 && response?.data?.data) {
//       const { userId, deviceId, refreshToken, accessToken, tokenType, action } =
//         response?.data?.data
//       return {
//         userId,
//         deviceId,
//         refreshToken,
//         accessToken,
//         tokenType,
//         action,
//         code: response?.data?.code
//       }
//     } else {
//       return null
//     }
//   } catch (error) {
//     console.error('Token validation failed:', error)
//     return null
//   }
// }

// // Axios client API instance
// export const clientAPI = axios.create()

// // Create a global AbortController to handle request cancellations
// let abortController = new AbortController()

// const getUserId = async () => {
//   const { store } = await import('../../../redux/store')
//   const userDetails = store.getState().user
//   return userDetails?.user?.userId
// }

// let anonymousTokenPromise = null

// const ensureAnonymousToken = async () => {
//   let token = getUserToken()
//   let deviceId = getDeviceId()

//   if (token && deviceId) {
//     return { token, deviceId }
//   }

//   if (anonymousTokenPromise) {
//     return anonymousTokenPromise
//   }

//   anonymousTokenPromise = (async () => {
//     try {
//       const response = await getValidatedToken({
//         accessToken: null,
//         deviceId: null,
//         userId: null,
//         refreshToken: null
//       })
//       if (response?.code == 200) {
//         setCookie(null, 'userToken', response?.accessToken, {
//           maxAge: 24 * 60 * 60 * 6,
//           path: '/'
//         })
//         setCookie(null, 'deviceId', response?.deviceId, {
//           maxAge: 24 * 60 * 60 * 6,
//           path: '/'
//         })

//         return {token: response.accessToken, deviceId: response.deviceId}
//       }

//       return {token: null, deviceId: null}
//     } catch (error) {
//       console.error(error)
//       return {token: null, deviceId: null}
//     } finally {
//         anonymousTokenPromise = null
//     }
//   })()
//   return anonymousTokenPromise
// }

// clientAPI.interceptors.request.use(
//   async (config) => {
//     let token = getUserToken()
//     let deviceId = getDeviceId()
//     const userId = await getUserId()

//     if (!userId && !token) {
//         const result = await ensureAnonymousToken()
//         token = result.token
//         deviceId = result.deviceId
//     }

//     if (token && deviceId) {
//       config.headers.Authorization = `Bearer ${token}`
//       config.headers.device_id = deviceId
//     } else {
//       config.headers.Authorization = `Bearer ${null}`
//       config.headers.device_id = `${null}`
//     }

//     // Add the abort controller signal to the request
//     config.signal = abortController.signal

//     return config
//   },
//   (error) => {
//     return Promise.reject(error)
//   }
// )

// // Function to get user ID

// let isRefreshing = false
// let refreshPromise = null
// let retryAfterDelay = false

// // Axios response interceptor for handling token refresh
// clientAPI.interceptors.response.use(
//   async (response) => {
//     return response
//   },
//   async (error) => {
//     const originalRequest = error.config

//     let accessToken = getUserToken()
//     let refreshToken = getRefreshToken()
//     let deviceId = getDeviceId()
//     const userId = await getUserId()

//     const { store } = await import('../../../redux/store')

//     if (error?.response?.status === 401 && !originalRequest?._retry) {
//       originalRequest._retry = true

//       if (!isRefreshing) {
//         isRefreshing = true
//         try {
//           const response = await getValidatedToken({
//             accessToken,
//             refreshToken,
//             deviceId,
//             userId
//           })

//           if (response?.action?.toLowerCase() === 'logout') {
//             originalRequest._retry = false
//             refreshPromise = true
//             Logout(null, response)
//             return Promise.reject(
//               new Error('User logged out, request cancelled.')
//             )
//           }

//           if (
//             (response?.code === 200 && response?.refreshToken) ||
//             response?.userId
//           ) {
//             nookieProvider('Auth', response)
//             originalRequest.headers.Authorization = `Bearer ${response?.accessToken}`
//             return clientAPI(originalRequest)
//           } else {
//             Logout(null, response)
//             nookieProvider('NoAuth', response)
//             originalRequest.headers.Authorization = `Bearer ${response?.accessToken}`
//             return clientAPI(originalRequest)
//           }
//         } catch (error) {
//           originalRequest._retry = false
//           refreshPromise = true
//           if (refreshToken || userId) {
//             logout()
//           } else {
//             nookieProvider('generate', cookies)
//           }
//           console.error('Error during token refresh:', error)
//         } finally {
//           isRefreshing = false
//         }
//       } else {
//         // Handle request queue when token refresh is in progress
//         if (!refreshPromise) {
//           refreshPromise = new Promise((resolve) => {
//             setTimeout(async () => {
//               await clientAPI(originalRequest)
//               resolve()
//               refreshPromise = null
//             }, 10000)
//           })
//         }
//         await refreshPromise
//       }
//     } else if (error?.response?.status === 403) {
//       //   store.dispatch(clearCart());
//       //   store.dispatch(clearAddress());
//       //   store.dispatch(logout());
//       //   nookieProvider("generate", cookies);
//     } else if (error?.response?.status === 429) {
//       // Rate limit exceeded, retry after a delay (example: 30 seconds)
//       retryAfterDelay = true
//       setTimeout(() => {
//         retryAfterDelay = false
//         clientAPI(originalRequest)
//       }, 30000) // Retry after 30 seconds
//       return Promise.reject(error)
//     }

//     return Promise.reject(error)
//   }
// )

// // Cancel ongoing request if necessary
// export const cancelRequest = () => {
//   abortController.abort()
//   abortController = new AbortController() // Recreate the AbortController for future requests
// }

import {
  getBaseUrl,
  getDeviceId,
  getRefreshToken,
  getUserToken
} from '@/lib/GetBaseUrl'
import { Logout } from '@/lib/handleLogout'
import { nookieProvider } from '@/lib/nookieProvider'
import { clearAddress } from '@/redux/features/addressSlice'
import { clearCart } from '@/redux/features/cartSlice'
import { logout } from '@/redux/features/userSlice'
import axios from 'axios'

export const getValidatedToken = async ({
  accessToken = null,
  deviceId = null,
  refreshToken = null,
  userId = null
}) => {
  let queryParams = ''

  if (refreshToken || userId) {
    queryParams = `?AccessToken=${encodeURIComponent(
      accessToken
    )}&RefreshToken=${encodeURIComponent(
      refreshToken
    )}&DeviceId=${encodeURIComponent(deviceId)}&UserId=${encodeURIComponent(
      userId
    )}`
  } else {
    queryParams = `?AccessToken=${encodeURIComponent(
      accessToken
    )}&DeviceId=${encodeURIComponent(deviceId)}`
  }

  try {
    const response = await axios.get(
      `${getBaseUrl()}Account/Customer/ValidateToken${queryParams}`
    )

    if (response?.data?.code === 200 && response?.data?.data) {
      const { userId, deviceId, refreshToken, accessToken, tokenType, action } =
        response.data.data

      return {
        userId,
        deviceId,
        refreshToken,
        accessToken,
        tokenType,
        action,
        code: response.data.code
      }
    }

    return null
  } catch (error) {
    console.error('Token validation failed:', error)
    return null
  }
}

export const clientAPI = axios.create()

let abortController = new AbortController()

const getUserId = async () => {
  const { store } = await import('../../../redux/store')

  const userDetails = store.getState().user

  return userDetails?.user?.userId
}

// --- Anonymous token handling ---
// anonymousTokenPromise: de-dupes concurrent generation calls so N requests
// hitting a missing/expired anonymous token in the same tick only trigger
// ONE ValidateToken call.
// anonymousTokenData: in-memory cache, independent of cookie read/write
// timing.
let anonymousTokenPromise = null
let anonymousTokenData = null

/**
 * Resolves { token, deviceId } for the current request.
 *
 * @param {boolean} force - when true, skips the cookie/cache/logged-in
 * short-circuits and goes straight to generating (or joining an in-flight
 * generation of) a fresh anonymous token. Use this when you already KNOW
 * the cached/cookie token is stale (e.g. it just 401'd) — otherwise the
 * cookie check below would just hand the same bad token straight back.
 */
const ensureAnonymousToken = async (force = false) => {
  if (!force) {
    // 1. Cookies already have a valid token (covers logged-in users too)
    let token = getUserToken()
    let deviceId = getDeviceId()

    if (token && deviceId) {
      anonymousTokenData = { token, deviceId }
      return anonymousTokenData
    }

    // 2. In-memory cache from a previous successful generation
    if (anonymousTokenData?.token && anonymousTokenData?.deviceId) {
      return anonymousTokenData
    }

    // 3. Logged-in user with no readable token yet — don't mint an
    // anonymous token for them, let the response interceptor's 401/refresh
    // flow handle it.
  }

  // 4. A generation request is already in flight — piggyback on it
  if (anonymousTokenPromise) {
    return anonymousTokenPromise
  }

  // 5. Generate a new anonymous token
  anonymousTokenPromise = (async () => {
    try {
      if (!force) {
        // Re-check in case cookies/cache were populated while we were
        // getting here

        const userId = await getUserId();
        if (userId) {
          return { token: null, deviceId: null }
        }

        const token = getUserToken()
        const deviceId = getDeviceId()

        if (token && deviceId) {
          anonymousTokenData = { token, deviceId }
          return anonymousTokenData
        }
      }

      const response = await getValidatedToken({
        accessToken: null,
        deviceId: null,
        userId: null,
        refreshToken: null
      })

      if (response?.code === 200 && response?.accessToken) {
        anonymousTokenData = {
          token: response.accessToken,
          deviceId: response.deviceId
        }

        nookieProvider('Auth', response)

        return anonymousTokenData
      }

      anonymousTokenData = null
      return { token: null, deviceId: null }
    } catch (error) {
      console.error('Anonymous token generation failed:', error)
      anonymousTokenData = null
      return { token: null, deviceId: null }
    } finally {
      anonymousTokenPromise = null
    }
  })()

  return anonymousTokenPromise
}

let isRefreshing = false
let refreshPromise = null
let retryAfterDelay = false

clientAPI.interceptors.request.use(
  async (config) => {
    const { token, deviceId } = await ensureAnonymousToken()
    config.headers = config.headers || {}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if (deviceId) {
      config.headers.device_id = deviceId
    }

    config.signal = abortController.signal

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

clientAPI.interceptors.response.use(
  async (response) => {
    return response
  },

  async (error) => {
    const originalRequest = error.config

    // Safety check
    if (!originalRequest) {
      return Promise.reject(error)
    }

    const { store } = await import('../../../redux/store')

    if (error?.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true

      const currentAccessToken = getUserToken()
      const currentRefreshToken = getRefreshToken()
      const currentDeviceId = getDeviceId()
      const currentUserId = await getUserId()

      if (!currentUserId) {
        // Anonymous session — the cached/cookie token we sent just got
        // rejected, so it's stale. Force-generate a fresh one (de-duped
        // against any other concurrent 401s hitting this same path) and
        // retry this one request. We do NOT loop again after this because
        // originalRequest._retry is already true.

        anonymousTokenData = null

        const { token, deviceId } = await ensureAnonymousToken(true)

        if (!token) {
          return Promise.reject(error)
        }

        originalRequest.headers = originalRequest.headers || {}
        originalRequest.headers.Authorization = `Bearer ${token}`

        if (deviceId) {
          originalRequest.headers.device_id = deviceId
        }

        return clientAPI(originalRequest)
      }

      if (!isRefreshing) {
        isRefreshing = true

        try {
          const response = await getValidatedToken({
            accessToken: currentAccessToken,
            refreshToken: currentRefreshToken,
            deviceId: currentDeviceId,
            userId: currentUserId
          })

          if (response?.action?.toLowerCase() === 'logout') {
            originalRequest._retry = false
            refreshPromise = true

            Logout(null, response)

            return Promise.reject(
              new Error('User logged out, request cancelled.')
            )
          }

          if (
            (response?.code === 200 && response?.refreshToken) ||
            response?.userId
          ) {
            nookieProvider('Auth', response)

            originalRequest.headers = originalRequest.headers || {}

            originalRequest.headers.Authorization = `Bearer ${response.accessToken}`

            if (response?.deviceId) {
              originalRequest.headers.device_id = response.deviceId
            }

            return clientAPI(originalRequest)
          }

          return Promise.reject(new Error('Unable to refresh token.'))
        } catch (refreshError) {
          originalRequest._retry = false
          refreshPromise = true

          if (currentRefreshToken || currentUserId) {
            store.dispatch(logout())
          }

          console.error('Error during token refresh:', refreshError)

          return Promise.reject(refreshError)
        } finally {
          isRefreshing = false
        }
      }

      if (!refreshPromise) {
        refreshPromise = new Promise((resolve, reject) => {
          setTimeout(async () => {
            try {
              await clientAPI(originalRequest)
              resolve()
            } catch (error) {
              reject(error)
            } finally {
              refreshPromise = null
            }
          }, 10000)
        })
      }

      await refreshPromise
    } else if (error?.response?.status === 403) {
      store.dispatch(clearCart())
      store.dispatch(clearAddress())
      store.dispatch(logout())

      nookieProvider('NoAuth', null)
    } else if (error?.response?.status === 429) {
      retryAfterDelay = true

      setTimeout(() => {
        retryAfterDelay = false
        clientAPI(originalRequest)
      }, 30000)

      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
)

export const cancelRequest = () => {
  abortController.abort()

  abortController = new AbortController()
}
